import { Vue, Component, Prop } from 'vue-property-decorator';
import { TreeNodeObject } from '~/interfaces/helper.interface';
import { DevicesModule } from '~/store/modules/devices';
import { HomesModule } from '~/store/modules/homes';
import { filterOnSearchText } from '~/helpers';

@Component
export default class TreeMixin extends Vue {
    @Prop() readonly search!: string;

    isActive(item: TreeNodeObject) {
        if (item.canBeActive) {
            switch (item.type) {
                case 'home':
                    return HomesModule.currentHomeId === item.id;
                case 'gateway':
                    return DevicesModule.currentGatewayId === item.id;
                case 'module':
                    return DevicesModule.currentModuleId === item.id
                        && DevicesModule.currentModule?.bridge === item.gatewayId;
            }
        }
    }

    isHighlighted(info: string) {
        return this.search && filterOnSearchText({ info } as any, this.search, ['info'] as any);
    }
}
